import { type PlatformEvent } from '@/shared/service/analytics/types';

import { ApiService } from '../ApiService';

export const sendAnalyticsEvent = (event: PlatformEvent) => {
  return ApiService.instance.post('api/v1/analytics', event);
};
